import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { OrganizationScope } from "@core/features/organization";
import type { NetworkGraphData } from "../components/NetworkGraph";

/**
 * What the interactive network graph draws, or the fact that it is switched
 * off.
 *
 * The switch is on the backend so that the data is never sent while the graph
 * is off, rather than being sent and hidden. The graph changes slowly and is
 * rebuilt there at most once a day, so one fetch serves a visit.
 *
 * `scope` is which organizations are drawn: the featured ones, the ones staff
 * listed themselves, or every approved one.
 */
export function useNetworkGraph(scope: OrganizationScope = "all") {
  return useQuery({
    queryKey: ["networkGraph", scope],
    queryFn: (): Promise<NetworkGraphData> =>
      apiRequest(
        `/marketing/network-graph/?scope=${scope}`,
        "GET",
        undefined,
        false
      ),
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
}
